module.exports = __webpack_public_path__ + "img/naggets.9b68ced0.png";